<vnm-persistent-notification
  icon="address-card"
  header="fields-required-notification.title"
  [message]="messageTranslation | translate: messageTranslationParams"
></vnm-persistent-notification>
